import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useParams } from "react-router-dom";
import axios from 'axios';
import { BaseURL, uniqueToken } from '../../../api/DataApis';
import "../../Users/User.css"; // Assuming you have some basic CSS here

function View(props) {
  document.title = "Filter Category | View";
  let navigate = useNavigate();
  let location = useLocation();
  const params = useParams();
  const MasterID = params.zid;

  let FilterCategoryViewtData = location.state.FilterCategoryViewtData;
  const [MasterExtraDetails, setMasterExtraDetails] = useState([]);
  const [loading, setLoading] = useState(true); // State to manage loader

  const fetchData = async () => {
    const apiEndpoint = `${BaseURL}/master/detail/${MasterID}`;
    try {
      let res = await axios.get(apiEndpoint, {
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${uniqueToken}`,
        }
      });

      if (res && res?.data && res?.data?.data && res?.data?.data?.length > 0) {
        setMasterExtraDetails(res?.data?.data[0]); // Set the first item in the data array
      } else {
        console.error("No charger data found");
      }
    } catch (error) {
      console.error("Error fetching charger data:", error);
    } finally {
      setLoading(false); // Stop the loader when data is fetched
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  console.log("data", MasterExtraDetails);

  return (
    <div className="container-fluid">
      <div className="row justify-content-center">
        <div className="col-sm-12">
          <div className="card mt-4 p-4">
            {loading ? (
              <div className="text-center">
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : (
              <>
                <h2 className="text-center">Category Details</h2>

                {/* Centered Image */}
                {MasterExtraDetails?.master_image && (
                  <div className="text-center mb-4">
                    <img
                      src={MasterExtraDetails.imageURL}
                      alt="Station"
                      style={{
                        width: '200px',
                        height: '200px',
                        objectFit: 'cover',
                        borderRadius: '50%',
                        border: '3px solid #ddd'
                      }}
                    />
                  </div>
                )}

                <div className="row">
                  <div className="col-sm-6">
                    <p><strong>Category Name:</strong> {MasterExtraDetails?.title}</p>
                  </div>
                  <div className="col-sm-6">
                    <p><strong>Slug:</strong> {MasterExtraDetails?.slug}</p>
                  </div>
                  <div className="col-sm-6">
                    <p><strong>Status:</strong> {MasterExtraDetails?.status}</p>
                  </div>
                  <div className="col-sm-6">
                    <p><strong>Created Date:</strong> {MasterExtraDetails?.createdAt}</p>
                  </div>
                  <div className="col-sm-6">
                    <p><strong>Updated Date:</strong> {MasterExtraDetails?.updatedAt}</p>
                  </div>
                  <div className="col-sm-6">
                    <p><strong> Power:</strong> {MasterExtraDetails?.master_select_power_id?.[0]?.title || "N/A"}</p>
                  </div>
                  <div className="col-sm-6">
                    <p><strong>Vehicle:</strong> {MasterExtraDetails?.master_select_vehicle_type_id?.[0]?.title || "N/A"}</p>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default View;
